export default {
  SET_REPORTS_LOADING (state, reportsLoading) {
    state.reportsLoading = reportsLoading
  },
  SET_REPORTS(state, reportTypes) {
    state.reportTypes = reportTypes;
    state.reportsLoading = false;
    state.reportsHaveLoaded = true;
    state.reportingUserMessage = '';
    state.reportingStatus = '';
  },
  SET_GENERATING_REPORT (state, generatingReport) {
    state.generatingReport = generatingReport
  },
  CLEAR_REPORTING (state) {
		state.generatingReport = false;
		state.multipleReportsDownloading = false;
		state.reportNavCategories = [];
		state.reportProcessed = false;
		state.reportTypes = [];
		state.reportingStatus = '';
		state.reportingUserMessage = '';
		state.reportsDownloading = {};
		state.reportsHaveLoaded = false;
		state.reportsLoading = false;
		state.selectedReportType = 'All';
  },

  SET_REPORTING_USER_MESSAGE (state, reportingUserMessage) {
    state.reportingUserMessage = reportingUserMessage;
  },

  SET_REPORTING_STATUS (state, reportingStatus) {
    state.reportingStatus = reportingStatus;
  },

  SET_REPORT_DOWNLOADING (state, { reportId, reportIsDownloading }) {
    state.reportsDownloading[reportId] = reportIsDownloading;
  },

  SET_MULTIPLE_REPORTS_DOWNLOADING (state, multipleReportsDownloading) {
    state.multipleReportsDownloading = multipleReportsDownloading
  }

}